var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "vue-book-resize-line",
    class: { "vue-book-resize-line--is-horizontal": _vm.isHorizontal },
    attrs: { draggable: "" },
    on: { drag: _vm.onDrag }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }